import { useCallback } from 'react';
import { trackEvent } from '@services/tracking';
import { useTogglePinPost } from '../api/useTogglePinPost';
import { CommunityId } from '../model/community.types';
import { MAX_PINNED_POSTS } from '../model/community.constants';
import { Post } from '../model/post.types';

const PIN_LIMIT_COPY = 'Pin limit reached. Unpin a post to add a new one.';

export type PinPostAction = {
  checked: boolean;
  disabled: boolean;
  helperText?: string;
  toggle: () => void;
};

export const usePinPostAction = (
  post: Post,
  communityId: CommunityId,
  pinnedCount: number,
): PinPostAction => {
  const togglePin = useTogglePinPost(communityId);
  const blockedByLimit = !post.pinned && pinnedCount >= MAX_PINNED_POSTS;

  const toggle = useCallback(() => {
    const nextPinned = !post.pinned;
    togglePin(post.id, nextPinned);
    trackEvent({ type: nextPinned ? 'Post pinned' : 'Post unpinned' });
  }, [post.pinned, post.id, togglePin]);

  return {
    checked: post.pinned,
    disabled: blockedByLimit,
    helperText: blockedByLimit ? PIN_LIMIT_COPY : undefined,
    toggle,
  };
};
